module.exports = __webpack_public_path__ + "static/media/qy_bg.b24f5e6d.png";